import { render, staticRenderFns } from "./Talla.vue?vue&type=template&id=665c791c&"
import script from "./Talla.vue?vue&type=script&lang=js&"
export * from "./Talla.vue?vue&type=script&lang=js&"
import style0 from "./Talla.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports